<template>
  <div class="background_news">
    <div class="news_index_text">
      <p style="font-size: 22px;margin-bottom: 1vh">我们的优势</p>
      <p style="font-size: 27px;margin: 0">感念际遇 不生苦毒</p>
      <p style="font-size: 27px; margin-bottom: 3vh;">尊重对手 战胜自己</p>
      <p style="font-size: 12px">十余年来，海纳亚洲主要聚焦投资科技、传媒、消费品、</p>
      <p style="font-size: 12px">现代服务、医疗、环保等领域。</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "News_index_m",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.news_index_text {
  padding-top: 34vh;
  text-align: center;
}

.background_news {
  background-image: url("../../../assets/background/index_news.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

</style>